export default "__VITE_ASSET__16358fd1__"